export default "__VITE_ASSET__3576910a__"